import { defineMessage } from "react-intl";

/* Search object types */
export const SEARCH_RESULTS_OBJECT_TYPE_FILE = "file";
export const SEARCH_RESULTS_OBJECT_TYPE_CUSTOMER = "customer";
export const SEARCH_RESULTS_OBJECT_TYPE_POST = "post";

/* Search metadata types */
export const SEARCH_RESULTS_METADATA_TYPE_PAGE = "page";
export const SEARCH_RESULTS_METADATA_TYPE_ARTICLE = "article";
export const SEARCH_RESULTS_METADATA_TYPE_EVENT = "event";
export const SEARCH_RESULTS_METADATA_TYPE_ASSOCIATION = "association";

export const SEARCH_RESULTS_TYPES = {
  /* Search object types */
  [SEARCH_RESULTS_OBJECT_TYPE_FILE]: {
    id: SEARCH_RESULTS_OBJECT_TYPE_FILE,
    label: defineMessage({ defaultMessage: "Fichier" }),
    icon: "ms_file_copy",
  },
  [SEARCH_RESULTS_OBJECT_TYPE_CUSTOMER]: {
    id: SEARCH_RESULTS_OBJECT_TYPE_CUSTOMER,
    label: defineMessage({ defaultMessage: "Compte Client" }),
    icon: "ms_person",
  },
  [SEARCH_RESULTS_OBJECT_TYPE_POST]: {
    id: SEARCH_RESULTS_OBJECT_TYPE_POST,
    label: defineMessage({ defaultMessage: "Contenu" }),
    icon: "ms_feed",
  },

  /* Search metadata types */
  [SEARCH_RESULTS_METADATA_TYPE_PAGE]: {
    id: SEARCH_RESULTS_METADATA_TYPE_PAGE,
    label: defineMessage({ defaultMessage: "Page" }),
    icon: "ms_news",
  },
  [SEARCH_RESULTS_METADATA_TYPE_ARTICLE]: {
    id: SEARCH_RESULTS_METADATA_TYPE_ARTICLE,
    label: defineMessage({ defaultMessage: "Article" }),
    icon: "ms_newspaper",
  },
  [SEARCH_RESULTS_METADATA_TYPE_EVENT]: {
    id: SEARCH_RESULTS_METADATA_TYPE_EVENT,
    label: defineMessage({ defaultMessage: "Agenda" }),
    icon: "ms_calendar_month",
  },
  [SEARCH_RESULTS_METADATA_TYPE_ASSOCIATION]: {
    id: SEARCH_RESULTS_METADATA_TYPE_ASSOCIATION,
    label: defineMessage({ defaultMessage: "Association" }),
    icon: "ms_diversity_1",
  },
};

export const SEARCH_RESULTS_METADATA_TYPE_LIST =
  Object.values(SEARCH_RESULTS_TYPES);
